import { css, SerializedStyles } from '@emotion/core';
import { Theme, normalText, titleText, helpText } from 'features/Theme';

const styles = {
  roundedContainer: (theme: Theme): SerializedStyles => css`
    background-color: ${theme.mui.palette.background.paper};

    padding: ${theme.mui.spacing(1)}px;

    ${theme.mui.breakpoints.up('sm')} {
      padding: ${theme.mui.spacing(5)}px;
      border-radius: ${theme.shape.borderRadiusLarge}px;
      ${!theme.embedded &&
        css`
          border: 1px solid ${theme.mui.palette.divider};
        `}
    }
  `,

  pageTitleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    text-align: center;
  `,

  creditLimitTitle: (theme: Theme): SerializedStyles => css`
    font-size: ${theme.mui.typography.body1.fontSize};
    color: ${theme.mui.palette.text.secondary};
    text-align: center;
    font-weight: lighter;
  `,

  dspContentPlacement: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    &, p {
      ${normalText(theme)}
      margin-bottom: ${theme.mui.spacing(1)}px;
    }
  `,

  dspSection: (theme: Theme): SerializedStyles => css`
    /**
     * This have to !important because this class is applied on a
     * Grid component, which sets its own margin. The order of precedence
     * here seems to be quite flakey. Sometimes this line takes precedence,
     * sometimes Grid's margin does.
     *
     * Ideally we don't apply layout-related styling on a Mui layout component,
     * but this class has to detect empty sections not render any
     * border/spacing and so it must be a direct parent of the content.
     */
    margin-top: ${theme.mui.spacing(2)}px !important;
    padding-top: ${theme.mui.spacing(2)}px;
    border-top: solid 1px ${theme.mui.palette.divider};
    &:empty {
      margin-top: 0;
      padding-top: 0;
      border-top: none;
    }
  `,

  actionsContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  disclosureSectionTitle: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
  `,

  disclosureSectionSubtitle: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    color: ${theme.mui.palette.text.secondary};
    font-size: 2rem;
  `,

  creditLimitText: (theme: Theme): SerializedStyles => css`
    color: ${theme.mui.palette.text.primary};
    font-size: 4.8rem;
    text-align: center;
    font-weight: bold;
  `,

  normalText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(1)}px;
  `,

  expandableDisclosure: (theme: Theme) => css`
    ${helpText(theme)}
  `,
  dspValue: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
  `,

  link: (theme: Theme): SerializedStyles => css`
    border: none;
    background: inherit;
    text-decoration: underline;
    curser: pointer;
    display: inline-block;
    padding: 0;
    color: ${theme.mui.palette.text.secondary};

    &:hover {
      color: ${theme.mui.palette.text.primary};
    }
  `,

  emailLink: (theme: Theme): SerializedStyles => css`
    font-size: ${theme.mui.typography.caption.fontSize};
  `,

  modalCloseButton: (theme: Theme): SerializedStyles => css`
    margin: 0 ${theme.mui.spacing(2)}px;
  `,

  notBestAprContent: (theme: Theme): SerializedStyles => css`
    h2 {
      ${titleText(theme)}
      font-weight: ${theme.mui.typography.fontWeightMedium};
      margin-bottom: ${theme.mui.spacing(3)}px;
      margin-top: ${theme.mui.spacing(2)}px;
    }

    p,
    li {
      ${normalText(theme)}
      color: ${theme.mui.palette.text.secondary};
    }

    p, address {
      margin-bottom: ${theme.mui.spacing(2)}px;
    }
  `,
};

export default styles;
